import React from 'react'

export const PageNotFound = () => {
  return (
    <>
      404 page
    </>
  )
}
